const labels = {
  All: { 'See the offering': 'ראה את ההנפקה' },
  FacilityDetails: { 'Ref: Page title': 'פרטי המתקן', 'Ref: Review': 'סקירה' },
  FacilitiesList: { 'Ref: Page title': 'מתקנים', 'Ref: See details': 'ראה פרטים' },
};
export default labels;
